module.exports = __webpack_public_path__ + "static/media/landing.1d853b06.png";